module.exports = __webpack_public_path__ + "img/arrow-filter.9cf64bed.svg";